<template>
  <div v-if="hasAccess">
    <slot />
  </div>
</template>

<script>
import permissionsService from '@/plugins/permissions/permissionsService'

export default {
  name: 'CanAccess',
  props: {
    permission: { type: String, required: true },
    module: { type: String, default: null },
    fallbackRoles: { type: Array, default: () => [] },
    allRoles: { type: Boolean, default: false },
    section: { type: String, default: null }
  },
  data() {
    return {
      hasAccess: false
    }
  },
  created() {
    this.checkAccess()
    window.addEventListener('permissions-updated', this.checkAccess)
  },
  beforeDestroy() {
    window.removeEventListener('permissions-updated', this.checkAccess)
  },
  methods: {
    checkAccess() {
      this.hasAccess = permissionsService.hasPermissionOrFallback({
        permission: this.permission,
        module: this.module,
        fallbackRoles: this.fallbackRoles,
        allRoles: this.allRoles,
        section: this.section
      })
    }
  },
  watch: {
    permission: 'checkAccess',
    module: 'checkAccess',
    type: 'checkAccess',
    fallbackRoles: 'checkAccess',
    allRoles: 'checkAccess'
  }
}
</script>